module.exports = __webpack_public_path__ + "static/media/signup-img.d0bda10e.svg";